// Strings for S0b. Only the S0b worker edits this file (see web/README.md).
// Copy from prototype/index.html (#S0b) and ux-flow.md S0b; DRAFT = no source there (w2-03 report).
export default {
  title: 'Scan your boarding pass',
  sub: 'The barcode holds your flight, your name and your booking reference — one scan and you can skip ahead.',
  zoneTitle: 'Point your camera at the barcode',
  zoneSub: 'or upload a photo, screenshot or PDF',
  privacy: 'We read the barcode and keep only your flight details.',
  reading: 'Reading your boarding pass…',
  stillWorking: 'Still working — some passes take a little longer.', // DRAFT
  'fail.unreadable':
    "We couldn't read that one. The barcode needs to be sharp and fully in frame — or tell us about your flight instead.",
  'fail.too_large': 'That file is too big — the limit is 10 MB. Try a photo or a screenshot instead.', // DRAFT
  'fail.unsupported': 'We can read photos (JPG, PNG, WebP, HEIC) and PDFs — try one of those.', // DRAFT
  'fail.network': "That didn't go through. Check your connection and try again.", // DRAFT
  'fail.robot': "We couldn't confirm you're not a robot. Please try again.", // DRAFT (w5-11)
  // DRAFT (w5-03): the reader or the API is down: our side, not the photo or the connection.
  'fail.unavailable':
    "We can't read boarding passes right now — that's on our side, not your photo. Try again in a minute, or enter your flight details instead.",
  'fail.empty': 'That file is empty. Try another photo, screenshot or PDF.', // DRAFT (w5-03)
  retry: 'Try again',
  enterDetails: 'Enter flight details instead',
} as const;
